<!DOCTYPE html>
<div [hidden]="true" id="hidden-primary" aria-hidden="true" class="bg-primary"></div>
<html id="campaign-layout-three-main" lang="en">
<head>
    <meta charset="UTF-8" />
    <!-- IE Compatibility Meta -->
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <!-- First Mobile Meta -->
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Fundraising Page</title>
</head>
<body onclick="void(0)">
    <!-- Start Header -->
    <header class="bg-primary">
        <div class="container custom-container">
            <div class="row">
                <div class="col-xs-6 col-sm-6 school-info">
                    <a *ngIf="showSchoolIconLogo" id="school-gallery-link" href="/gallery" target="_blank">
                        <img [src]="schoolIconLogo" alt="School Icon Logo" id="school-icon-logo" />
                    </a>
                    <h4 [ngClass]="{'mobile-hide-school-name': showSchoolIconLogo}"><a id="school-gallery-link" style="text-decoration:none;color:#ffffff;" href="/gallery" target="_blank">{{campaignInformation.schoolName}}</a></h4>
                </div>
                <div class="col-xs-6 col-sm-6">
                    <span [title]="!campaignInformation.canDonate ? 'This campaign is no longer accepting gifts.' : ''">
                        <button id="header-give-now-button" [disabled]="!campaignInformation.canDonate" (click)="onGiveNowClick()" class="btn btn-light" style="color:#000000">Give Now</button>
                    </span>
                </div>
            </div>
        </div> <!-- End Container -->
    </header> <!-- End Header -->
    <!-- Start Intro -->
    <section class="intro">
        <div class="container custom-container secret-sauce">
            <div class="col-xs-12">
                <div class="row flex-container">
                    <div class="flex-item">
                        <div class="info">
                            <h3>Raising ${{campaignInformation.goalAmount | number }} for my education</h3>
                            <p>{{campaignInformation.sections[0]}}</p>
                            <div class="buttons">
                                <span [title]="!campaignInformation.canDonate ? 'This campaign is no longer accepting gifts.' : ''">
                                    <button [disabled]="!campaignInformation.canDonate" id="intro-give-now-button" (click)="onGiveNowClick()" class="btn btn-primary bg-primary">Give Now</button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="profile">
                            <img *ngIf="showImage" [src]="profileImageUrl" (error)="onerror()" class="img-responsive" alt="Profile Picture" />
                            <div *ngIf="showInitials" class="circle">
                                <div class="circle-content"><h1 id="student-initials">{{campaignInformation.studentInitials}}</h1></div>
                            </div>
                            <h4>{{campaignInformation.studentName}}</h4>
                            <div class="student-info-box">
                                <label class="student-info-label">{{campaignInformation.yearInSchool}}</label>
                                <label class="student-info-label">{{campaignInformation.collegeName}}</label>
                                <label class="student-info-label">{{campaignInformation.major}} Major</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- End Container -->
    </section> <!-- End Intro -->
    <!-- Start Story -->
    <section class="story">
        <div class="container custom-container content-container">
            <div class="item">
                <h4>My Story</h4>
                <p>{{campaignInformation.sections[1]}}</p>
            </div>
            <div class="item">
                <h4>My Ask</h4>
                <p>{{campaignInformation.sections[2]}}</p>
            </div>
            <span [title]="!campaignInformation.canDonate ? 'This campaign is no longer accepting gifts.' : ''">
                <button id="story-give-now-button" [disabled]="!campaignInformation.canDonate" (click)="onGiveNowClick()" class="btn btn-primary bg-primary" style="color:#ffffff">Give Now</button>
            </span>
        </div> <!-- End Container -->
    </section> <!-- End Story -->
    <ss-gift-checkout-modal-component [show]="showCheckoutModal" [campaignInfo]="campaignInformation" (closed)="showCheckoutModal=false"></ss-gift-checkout-modal-component>
</body>
</html>